<template>
  <div id="modemSearchPopup">
    <div class="common_popup_top_wrap">
      <div class="common_popup_search_wrap">
        <input type="text" v-model="searchParams.searchKeyword" placeholder="이동전화번호를 입력하세요"/>
        <div class="btn_search" @click="search(1)">검색</div>
      </div>
      <div class="common_popup_search_notice">※ 010-1234-5678, 01012345678 모두 가능, 1234(부분검색) 가능</div>
    </div>
    <div class="common_list_wrap">
      <div class="common_list_top">
        <div>모뎀현황 (전체 {{pageParams.totalElements}}건)</div>
      </div>
      <div class="common_list_middle">
        <div class="common_list_head">
          <div><span><input type="checkbox" v-model="checkAll" @click.stop="onClickCheckAll"/></span></div>
          <div><span>본부</span></div>
          <div><span>구축구분</span></div>
          <div><span>이동전화번호</span></div>
          <div><span>처리현황</span></div>
          <div><span>현재상태</span></div>
        </div>
        <div class="common_list_body">
          <div class="common_list_no_data" v-if="list.length <= 0">
            <img src="../../assets/common/bg_list_no_data.png"/>
            <span>대상 모뎀이 없습니다.</span>
          </div>
          <div :key="'modem_' + item.modemPid" v-for="item in list">
            <div><span><input type="checkbox" v-model="item.check" :value="item.modemPid" @click.stop="onClickCheckItem(item)"/></span></div>
            <div>
              <span v-if="item.officeCode != null">
                <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === (item.officeCode.length === 5 ? item.officeCode : item.officeCode.substring(0, 5))">{{ofc1.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div>
              <span v-if="item.structType != null">
                <template v-for="stt in sttList" v-if="stt.codeValue === item.structType">{{stt.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div><span>{{item.mobileNum}}</span></div>
            <div>
              <span v-if="item.progressType != null">
                <template v-for="prg in prgList" v-if="prg.codeValue === item.progressType">{{prg.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div>
              <template v-if="item.currentState != null">
                <template v-for="crs in crsList" v-if="crs.codeValue === item.currentState">
                  <span :key="'crs_' + crs.codePid" class="btn_status fc_white" :class="item.currentState === 'CRS01' ? 'bc_status_green' : 'bc_status_red'">{{crs.codeName}}</span>
                </template>
              </template>
              <span v-else>-</span>
            </div>
          </div>
        </div>
      </div>
      <div class="common_bottom_wrap padding_wrap">
        <div class="btn_bottom btn_close" @click="hidePopup">닫기</div>
        <div class="common_list_page_wrap center_page">
          <paginate
            v-model="pageParams.page"
            :pageCount="pageParams.totalPage"
            :clickHandler="search"
            :prevText="'<'"
            :nextText="'>'"
            :containerClass="'page_wrap'">
          </paginate>
        </div>
        <div class="btn_bottom btn_blue_t" @click="addModemRequest">등록(선택)</div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '../../script/common'
import modemInfo from '../../script/modemInfo'
import {defaultLoadingOptions} from '../../script/defaultConfig'

export default {
  props: ['popupParams'],
  data () {
    return {
      // Data
      ofcList: [],
      ofc1List: [],
      sttList: [],
      prgList: [],
      crsList: [],
      // Search
      searchParams: {
        searchKeyword: '' // 키워드
      },
      // List
      filter: {
        page: 1,
        size: parseInt(this.selectSize)
      },
      selectSize: '10',
      list: [],
      checkAll: false,
      selectedItemList: [],
      // Paging
      pageParams: {
        hasNext: false,
        totalElements: 0,
        totalPage: 1,
        page: 10,
        size: parseInt(this.selectSize)
      }
    }
  },
  mounted () {
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        let intervalCnt = 0
        let interval = setInterval(() => {
          if (common.checkValidateData('session', sessionStorage.getItem('ofcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('sttList')) &&
            common.checkValidateData('session', sessionStorage.getItem('prgList')) &&
            common.checkValidateData('session', sessionStorage.getItem('crsList'))) {
            clearInterval(interval)
            this.ofcList = JSON.parse(sessionStorage.getItem('ofcList'))
            this.ofc1List = this.getOfc1List()
            this.sttList = JSON.parse(sessionStorage.getItem('sttList'))
            this.prgList = JSON.parse(sessionStorage.getItem('prgList'))
            this.crsList = JSON.parse(sessionStorage.getItem('crsList'))
            if (this.$route.params != null && this.$route.params.searchParams != null) {
              this.searchParams = this.$route.params.searchParams
              this.search(1)
            } else {
              this.search(1)
            }
          } else if (intervalCnt > 10) {
            clearInterval(interval)
            common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
          } else {
            intervalCnt++
          }
        }, 200)
      } else {
        common.amsAlert('general', '로그아웃 되었습니다.\n다시 로그인해주세요.')
        this.$router.replace('/Login')
      }
    })
  },
  methods: {
    hidePopup (args) {
      this.$emit('hidePopup', args)
    },
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    onClickCheckAll () {
      this.selectedItemList = []
      for (let i = 0; i < this.list.length; i++) {
        this.list[i].check = !this.checkAll
        if (!this.checkAll) {
          this.selectedItemList.push(this.list[i])
        }
      }
    },
    onClickCheckItem (selectedItem) {
      if (selectedItem.check) {
        this.selectedItemList = this.selectedItemList.filter(item => { return item.modemPid !== selectedItem.modemPid })
      } else {
        this.selectedItemList.push(selectedItem)
      }
      this.checkAll = this.selectedItemList.length === this.list.length
    },
    search (page) {
      this.filter = {
        page: page,
        size: parseInt(this.selectSize),
        sameOffice: true
      }
      delete this.filter['currentState']
      delete this.filter['currentStates']
      if (this.popupParams.searchType === 'USE') {
        this.filter.currentState = 'CRS01'
      } else if (this.popupParams.searchType === 'STOP') {
        this.filter.currentState = 'CRS03'
      } else if (this.popupParams.searchType === 'USEANDSTOP') {
        this.filter.currentStates = 'CRS01,CRS03'
      }
      delete this.filter['mobileNum']
      if (this.searchParams.searchKeyword != null && this.searchParams.searchKeyword.length > 0) {
        this.filter.mobileNum = this.searchParams.searchKeyword.replaceAll('-', '')
      }
      this.updateList()
    },
    updateList () {
      let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
      modemInfo.getModemInfo(this.filter, response => {
        console.log('무선모뎀 검색 팝업', response)
        vueLoadingOverlay.hide()
        if (response.data.resultCode === 1) {
          const data = response.data.result.body
          let list = data.list
          for (let i = 0; i < list.length; i++) {
            list[i].check = false
          }
          this.list = list
          this.pageParams = {
            hasNext: data.hasNext,
            totalElements: data.totalElements,
            totalPage: data.totalPage,
            page: this.filter.page,
            size: this.filter.size
          }
        } else {
          common.amsAlert('retry', '모뎀 목록을 불러오지 못했습니다.')
          this.list = []
          this.pageParams = {
            hasNext: false,
            totalElements: 0,
            totalPage: 1,
            page: 1,
            size: this.filter.size
          }
        }
        this.checkAll = false
        this.selectedItemList = []
      })
    },
    addModemRequest () {
      if (this.selectedItemList.length <= 0) {
        common.amsAlert('general', '먼저 모뎀을 선택하세요.')
        return
      }
      let numList = []
      for (let i = 0; i < this.selectedItemList.length; i++) {
        numList.push(this.selectedItemList[i].mobileNum)
      }
      this.$emit('setSelectedItemList', {type: 'AS', data: numList})
    }
  }
}
</script>

<style scoped>
#modemSearchPopup .common_popup_top_wrap {
  padding: 25px;
  background: #F8F8F8;
}

#modemSearchPopup .common_popup_top_wrap > .common_popup_search_wrap {
  display: flex;
  padding: 0 100px;
  gap: 20px;
}

#modemSearchPopup .common_popup_search_wrap > .btn_search {
  flex-shrink: 0;
  width: 77px;
  height: 56px;
  border-radius: 4px;
  border: 1px solid #E2E8ED;
  background: #3E7EFF;
  color: #FFF;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 56px;
  cursor: pointer;
}

#modemSearchPopup .common_popup_top_wrap > .common_popup_search_notice {
  margin: 16px auto 0;
  color: #36414F;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

#modemSearchPopup .common_list_wrap {
  width: 100%;
  margin-top: 25px;
}

#modemSearchPopup .common_list_wrap > .common_list_top {
  margin-left: 30px;
}

#modemSearchPopup .common_list_wrap > .common_list_top > div {
  color: #36414F;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
}

#modemSearchPopup .common_list_wrap > .common_list_middle {
  margin-top: 10px;
}

#modemSearchPopup .common_list_head > div {
  background: #F8F8F8;
}

#modemSearchPopup .common_list_middle > .common_list_body > div:nth-child(odd) {
  background: #FFFFFF;
}

#modemSearchPopup .common_list_middle > .common_list_body > div:nth-child(even) {
  background: #F8F8F8;
}

#modemSearchPopup .common_list_middle > .common_list_head > div,
#modemSearchPopup .common_list_middle > .common_list_body > div > div {
  width: 111px;
}

#modemSearchPopup .common_list_middle > .common_list_head > div:nth-child(1),
#modemSearchPopup .common_list_middle > .common_list_body > div > div:nth-child(1) {
  width: 13px;
}

#modemSearchPopup .common_list_middle > .common_list_body > div > div {
  color: #36414F;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}

#modemSearchPopup .common_bottom_wrap > .btn_bottom {
  height: 46px;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 46px;
}

#modemSearchPopup .common_bottom_wrap > .btn_close {
  width: 76px;
  margin: auto auto auto 0;
  color: #36414F;
}

#modemSearchPopup .common_bottom_wrap > .btn_blue_t {
  width: 118px;
  margin: auto 0 auto auto;
  color: #2D2D2D;
}

#modemSearchPopup .common_bottom_wrap > .common_list_page_wrap {
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ModemSearchPopup.vue